import { Col, Container, Row, Surface } from '@vst/beam';
import { Header } from '../Header';
import { LoadingSpinner } from '../LoadingSpinner';
import styles from './orderSubmittingAnimation.module.scss';

type OrderSubmittingAnimationProps = {
  loadingSpinnerSubheadingText: string;
  messagesArraySpinner: string[];
  phoneNumber: string;
  linkUrl: string;
  linkPrefix: string;
};

export function OrderSubmittingAnimation(props: OrderSubmittingAnimationProps) {
  return (
    <Surface variant="secondary" className={styles['root']}>
      <Surface className={styles['header']} data-testid="header">
        <Container fluidUntil={'xl'} className={styles['headerContainer']}>
          <Row edge2edge>
            <Col>
              <Header linkUrl={props.linkUrl} linkPrefix={props.linkPrefix} phoneNumber={props.phoneNumber} />
            </Col>

            <Surface className={styles['loadingSpinner']}>
              <LoadingSpinner
                size={'large'}
                text={props.loadingSpinnerSubheadingText}
                heading={props.messagesArraySpinner}
              />
            </Surface>
          </Row>
        </Container>
      </Surface>
    </Surface>
  );
}
